import { t } from 'i18next';
import { capitalize } from 'lodash';

export enum Columns {
  Site = 'site',
  Groups = 'groups',
  Validity = 'validity',
}

export type FilterKeys = Columns.Groups | Columns.Site | Columns.Validity;

export const FilterKeys = [Columns.Groups, Columns.Site, Columns.Validity] as const;

export enum MultiClaimValidity {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
}

export type FilterOption = {
  column: FilterKeys;
  label: string;
  value: string;
  id: string;
};

export type FilterOptions = {
  [key in FilterKeys]: { all: FilterOption[]; enabled: FilterOption[] };
};

export function getValidityFilterOptions(): FilterOption[] {
  return [
    {
      value: MultiClaimValidity.Active,
      label: capitalize(t('active')),
      column: Columns.Validity,
      id: MultiClaimValidity.Active,
    },
    {
      value: MultiClaimValidity.Expired,
      label: capitalize(t('expired')),
      column: Columns.Validity,
      id: MultiClaimValidity.Expired,
    },
  ];
}
